(function(){
  var course,track,runner,path=null,len=0,lastW=-1,lastH=-1,lastT=-1;
  function els(){course=document.getElementById('mst-course');track=document.getElementById('mst-track');runner=document.getElementById('mst-runner');return course&&track&&runner;}
  function build(){
    var w=Math.round(track.getBoundingClientRect().width),h=Math.round(course.getBoundingClientRect().height);
    if(!w||!h)return false;
    lastW=w;lastH=h;
    var mid=w/2,amp=Math.max(10,w*0.24),seg=Math.max(260,Math.min(520,h/9));
    var d='M '+mid+' 0',y=0,dir=1;
    while(y<h){var ny=Math.min(h,y+seg);d+=' C '+(mid+amp*dir)+' '+(y+seg*0.35)+', '+(mid+amp*dir)+' '+(y+seg*0.65)+', '+mid+' '+ny;y=ny;dir*=-1;}
    track.setAttribute('viewBox','0 0 '+w+' '+h);
    track.setAttribute('width',w);track.setAttribute('height',h);
    var sw=w<100?22:34;
    track.innerHTML='<path d="'+d+'" fill="none" stroke="#0e0e0e" stroke-width="'+(sw+8)+'" stroke-linecap="round"/><path class="mst-tp" d="'+d+'" fill="none" stroke="#f4793c" stroke-width="'+sw+'" stroke-linecap="round"/><path d="'+d+'" fill="none" stroke="#ffb48c" stroke-width="2.5" stroke-dasharray="2 20"/>';
    path=track.querySelector('.mst-tp');len=path.getTotalLength();lastT=-1;
    return true;
  }
  function place(){
    var r=course.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight;
    var t=(vh*0.5-r.top)/r.height;t=Math.max(0,Math.min(1,t));
    if(Math.abs(t-lastT)<0.0005)return;
    lastT=t;
    var at=t*len,a=path.getPointAtLength(Math.max(0,at-2)),b=path.getPointAtLength(Math.min(len,at+2)),pt=path.getPointAtLength(at);
    var ang=Math.atan2(b.y-a.y,b.x-a.x)*180/Math.PI-90;
    runner.style.transform='translate('+(pt.x-runner.offsetWidth/2)+'px,'+(pt.y-runner.offsetHeight/2)+'px) rotate('+(ang+180)+'deg)';
  }
  function tick(){
    if(course&&document.body.contains(course)){
      var w=Math.round(track.getBoundingClientRect().width),h=Math.round(course.getBoundingClientRect().height);
      if(w!==lastW||h!==lastH)build();
      if(path)place();
    }else if(els()){build();}
    requestAnimationFrame(tick);
  }
  function start(){if(els())build();requestAnimationFrame(tick);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();